export class AttributeValue {
    public id: number = 0;
    public name?: string;
    public selected: boolean = false;

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): AttributeValue {
        const attributeValue = new AttributeValue();

        attributeValue.id = this.id;
        attributeValue.name = this.name;
        attributeValue.selected = this.selected;

        return attributeValue;
    }
}
